import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5464_9794)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.502 11.6102L14.9102 13.6859V16.1585V17.8345L18.502 15.7588V11.6102ZM8.3947 6.55083L11.9865 8.62656L15.5783 6.55083L11.9865 4.4751L8.3947 6.55083ZM5.47382 13.6831V15.7588L6.44746 16.3184L9.06566 17.8316V13.6831L5.47382 11.6102V13.6859V13.6831ZM3.52658 16.8809V19.1308L2.55293 18.5683L1.57935 18.0058V11.9985V5.99122L11.9865 -0.0161133L22.3937 5.99122V18.0087L17.1886 21.0123L14.9074 22.3286V20.0786L20.4464 16.8809V8.23825L12.9601 12.561C12.9601 13.7602 12.9601 14.9565 12.9601 16.1557V23.4535L11.9865 24.016L11.0129 23.4535L6.78149 21.0123L5.47382 20.2586V18.0087L11.0129 21.2065V12.5638L3.52658 8.24108V16.8837V16.8809ZM11.9865 10.8736L4.50023 6.55083L11.9865 2.22808L19.4728 6.55083L11.9865 10.8736Z"
        fill="#FBFCFD"
      />
    </g>
    <defs>
      <clipPath id="clip0_5464_9794">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
